/* eslint-disable react-hooks/exhaustive-deps */
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import Page from "components/Page";
import withValidarRecuperar from "HOC/withValidarRecuperar";
import useCustomRouter from "hooks/useCustomRouter";
import useQueryParams from "hooks/useQueryParams";
import React, { useEffect } from "react";
import useAsegurados from "redux/hooks/emision/useAsegurados";
import { PASOS_BREADCRUMBS } from "utils/constants";
import Loading from "wrappers/Loading";
import Form from "./Form";
import Listado from "./Listado";

const EmisionAseguradosContainer = () => {
  const { codProducto } = useQueryParams();

  const history = useCustomRouter();

  const {
    fetchAsegurados,
    loadingCatalogo,
    isShowFormAdd,
    resetState,
    rutas,
    guardarAsegurados,
    loadingEditarBeneficiarios,
  } = useAsegurados();

  useEffect(() => {
    resetState();
    fetchAsegurados();
  }, []);

  const onClickAtras = async () => {
    history.push(rutas.asegurado.goBack);
  };
  const onClickContinuar = async () => {
    await guardarAsegurados();
  };
  return (
    <Loading loading={loadingCatalogo}>
      <Page>
        <BreadCurmb {...PASOS_BREADCRUMBS[codProducto]?.breadCrumb} />
        <BreadCrumbPasosV2
          {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasosEmision[1]}
          pasos={PASOS_BREADCRUMBS?.[codProducto]?.pasosEmision}
        />
        <div className='row justify-content-center'>
          <div className='col-md-11'>
            {isShowFormAdd && <Form />}
            <Listado />
          </div>
        </div>

        {!isShowFormAdd && (
          <div className='row justify-content-center mb-5'>
            <div className='col-11 col-sm-12 col-lg-11 '>
              <div className='row justify-content-center' style={{ marginTop: "5rem" }}>
                <div className='col-11 col-md-3 col-xl-2'>
                  <button
                    type='button'
                    className='btn btn-atras-api'
                    onClick={onClickAtras}
                    disabled={loadingEditarBeneficiarios}>
                    Atrás
                  </button>
                </div>

                <div className='col-11 col-md-3 col-xl-2'>
                  <button
                    className='btn btn-siguiente-api'
                    onClick={onClickContinuar}
                    type='button'
                    disabled={loadingEditarBeneficiarios}>
                    Siguiente
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Page>
    </Loading>
  );
};

export default withValidarRecuperar(EmisionAseguradosContainer);
